import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'agentZoneFilter'
})
export class AgentZoneFilterPipe implements PipeTransform {

  transform(value: any[], zone: string): any[] {
    if (zone !== '') {
      return value.filter(
        item => item.zone_name.toLowerCase().indexOf(zone.toLowerCase()) > -1);
    } else {
      return value;
    }
  }

}
